import Model from "./abstract/Model";
import Vehicle from "./Vehicle";

export default class Address extends Model {
    constructor(props) {
      super();

      this.initializeAttributes(props, {});
    }
}
